import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const LocationContext = createContext(null);

export const useLocations = () => {
  const ctx = useContext(LocationContext);
  if (!ctx) throw new Error("useLocations must be used within LocationProvider");
  return ctx;
};

export const LocationProvider = ({ children }) => {
  const [data, setData] = useState({
    items: [],
    active_location_id: null,
    max_allowed: 1,
    subscription_active: false,
  });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/locations");
      setData(data);
      return data;
    } catch (_) {
      // user no autenticado o aún no migrado — silencioso
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const switchLocation = useCallback(async (locationId) => {
    await api.post(`/locations/${locationId}/switch`);
    // Hard reload para asegurar que TODAS las páginas re-fetchean datos con la nueva location activa
    window.location.reload();
  }, []);

  const currentLocation = data.items.find((l) => l.location_id === data.active_location_id) || data.items[0];

  return (
    <LocationContext.Provider value={{ ...data, currentLocation, loading, refresh, switchLocation }}>
      {children}
    </LocationContext.Provider>
  );
};
